exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container___1TRar {\n  padding: 40px;\n  width: 360px;\n}\n.modal-dialog.simple-signup-modal {\n  width: 360px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container___1TRar"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/modals/SimpleSignUpModal/styles.module.less
// module id = 1822
// module chunks = 70